import Button from "@material-ui/core/Button";
import React from "react";
import ReactGA from "react-ga4";

class RabButton extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.onClick = this.onClick.bind(this);
  }
  onClick = () => {
    let action = "";
    if (Array.isArray(this.props.children)) {
      action = this.props.children[0];
    }
    if (typeof this.props.children === 'string' || this.props.children instanceof String) {
      action = this.props.children
    }
    console.log("custom button click: " + this.props.children);
    ReactGA.event({
      category: "Button Click",
      action: action
    });
    if (this.props.onClick) {
      this.props.onClick();
    }
  };
  render() {
    return <Button {...this.props} onClick={this.onClick}></Button>;
  }
}

export default RabButton;
